import { render } from "./DashboardTableData.vue?vue&type=template&id=110e3ff1"
import script from "./DashboardTableData.vue?vue&type=script&lang=js"
export * from "./DashboardTableData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__